<template>
  <div class="mt-3 pa-2 rounded elevation-0 bordered bg-grey_3">
    <div class="d-flex align-center gap">
      <div class="text-h6">{{ item.nom }} {{ item.prenom }}</div>
      <v-icon :icon="item.sexe == 'M' ? 'mdi-gender-male' : 'mdi-gender-female'"
        :color="item.sexe == 'M' ? 'light-blue-darken-4' : 'deep-purple'"></v-icon>
    </div>
    <div class="text-subtitle-1">Parcours: {{ item.course.nom }}</div>
    <v-divider style="margin: 5px 0 !important"></v-divider>
    <div class="d-flex flex-column sm-gap">
      <div class="d-flex sm-gap">
        <v-icon icon="mdi-calendar" color="primary-dark"></v-icon>
        <div>{{ date_naissance }}</div>
      </div>
      <div class="d-flex sm-gap">
        <v-icon icon="mdi-email-outline" color="primary-dark"></v-icon>
        <div>{{ item.champs.mail }}</div>
      </div>
      <div class="d-flex sm-gap">
        <v-icon icon="mdi-phone" color="primary-dark"></v-icon>
        <div>{{ item.champs.telephone }}</div>
      </div>
      <v-divider style="margin: 5px 0 !important"></v-divider>
      <v-chip v-if="item.gia && item.gia.valide == '1'" prepend-icon="mdi-shield-account" color="green-darken-4"
        variant="elevated" elevation="0">
        A souscrit à la GIA <span v-if="mainStore.authAdmin.isSportipsAdmin">({{ item.gia.prix }}€)</span></v-chip>
      <v-chip v-if="item.alerte_sms && item.alerte_sms.valide == '1'" prepend-icon="mdi-message-processing-outline"
        color="primary-dark" variant="elevated" elevation="0">
        Alertes SMS <span v-if="mainStore.authAdmin.isSportipsAdmin"> ({{ item.alerte_sms.prix
        }}€)</span></v-chip>
      <v-chip v-if="item.plan_entrainement && item.plan_entrainement.valide == '1'" prepend-icon="mdi-run"
        color="primary-dark" variant="elevated" elevation="0">
        Plan d'entraînement <span v-if="mainStore.authAdmin.isSportipsAdmin"> ({{ item.plan_entrainement.prix
        }}€)</span></v-chip>

      <v-divider style="margin: 5px 0 !important"></v-divider>

    </div>
  </div>
</template>

<script>
import { useMainStore } from "@/stores/mainStore";
import { mapStores } from "pinia";
export default {
  props: ["item"],
  data() {
    return {
      info_list: [],
    };
  },
  computed: {
    ...mapStores(useMainStore),
    sexe_icon() {
      if (this.item.sexe == "M") {
        return "mdi-gend";
      }
      return "mdi-female";
    },
    date_naissance() {
      return "né le " + this.$moment(this.item.date_naissance).format("DD/MM/YYYY");
    },
  },
  methods: {
    build_infos_list() {
      /*      this.info_list.push({ icon: "mdi-calendar", text: , color: "primary-dark" });
      this.info_list.push({ icon: "mdi-mail", text: this.item.champs.mail, color: "primary-dark" });
      this.info_list.push({ icon: "mdi-phone", text: this.item.champs.tel, color: "primary-dark" });
      this.info_list.push({ icon: "mdi-map-marker", text: this.item.champs.adresse, color: "primary-dark" }); */
    },
  },
  created() {
    this.build_infos_list();
  },
};
</script>

<style lang="scss" scoped></style>